import React from "react";
import { Row, Col, Input, Drawer } from "antd";
import { Scrollbars } from "react-custom-scrollbars";
import closeX from "../../../../assets/images/close-x.svg";
import UserSearch from "../../../../assets/images/mdi_user-search.svg";
import CircleCloseIcon from "../../../../assets/images/remove.svg";
import View from "../../../../assets/images/view.svg";
import EditIcon from "../../../../assets/images/ri_edit-line.svg";
import CustomerIcon from "../../../../assets/images/customerIcon.png";
import data from "../../../../constants/retailPos.json";
import { getMultilingualText } from "../../../../utils/getMultilingualText";

const UAECustomerSearchDrawer = ({
  displayUAECustomerSearch,
  closeCustomerSearch,
  customerSearchInputRef,
  customerSearchInput,
  setCustomerSearchInput,
  customerSearchResults,
  setCustomerSearchResults,
  selectCustomer,
  showEditOldCustomerFields,
  setEditFlag,
  showAddNewUAECustomerFields,
  getInputValue,
  onFocusInput,
  onChangeInput,
}) => {
  console.log("customerSearchResults", customerSearchResults);
  return (
    <Drawer
      placement="bottom"
      closable={false}
      title={
        <div style={{ display: "flex", alignItems: "center", height: "4vh", fontSize: "1vw" }}>
          <p style={{ fontSize: "1.5em", marginTop: "0.6vh", fontWeight: "500", color: "#0F0718", flex: 1, marginLeft: "36vw" }}>Search for UAE customer</p>
          <img src={closeX} onClick={closeCustomerSearch} style={{ marginLeft: "auto", paddingBottom: "4vh", paddingTop: "2vh", cursor: "pointer", width: "1.5vw" }} />
        </div>
      }
      headerStyle={{ borderBottom: "none" }}
      bodyStyle={{ backgroundColor: "#f3f4f9" }}
      open={displayUAECustomerSearch}
      className="addCustomer"
      styles={{ body: { paddingBottom: 0, paddingTop: 0 } }}
      height="78vh"
    >
      <Row justify="center" style={{ marginTop: "0.1%", height: "8vh", overflow: "hidden" }}>
        <Col span={12} style={{fontSize: "1vw", display: "flex", alignItems: "center", justifyContent: "center" }}>
          <Input
            ref={customerSearchInputRef}
            placeholder="Search"
            id="sm-product-search"
            size="large"
            style={data.posScreenStyles.customerModal.customerSearchInput}
            className="customerSearchInput"
            prefix={<img src={UserSearch} style={data.posScreenStyles.customerModal.searchIcon} />}
            suffix={<img src={CircleCloseIcon} alt="" style={data.posScreenStyles.customerModal.searchIcon} 
            onClick={() => {
              setCustomerSearchInput("");
              setCustomerSearchResults([]);
              customerSearchInputRef?.current?.focus();
            }}
             className="remove_btn" />}
            value={customerSearchInput === "" ? getInputValue("search") : customerSearchInput}
            onFocus={() => {
              customerSearchInputRef.current?.focus();
              onFocusInput("search");
            }}
            onChange={(e) => {
              onChangeInput(e);
              e.target.value === ""
                ? (() => {
                    setCustomerSearchResults([]);
                    setCustomerSearchInput(e.target.value);
                  })()
                : setCustomerSearchInput(e.target.value);
            }}
          />
        </Col>
      </Row>
      <Row style={{ marginTop: "1%" }}>
        <Col span={22} style={{ marginLeft: "3vw", fontSize: "1vw" }}>
          {customerSearchResults === undefined ? (
            <div style={data.posScreenStyles.header.left}>
              <div
                bordered
                style={{
                  ...data.posScreenStyles.customerModal.customerSearchListEmpty,
                  minHeight: "50vh",
                  maxHeight: "50vh",
                   width: "auto",
                }}
              />
            </div>
          ) : customerSearchResults !== undefined && customerSearchResults.length > 0 ? (
            <div style={data.posScreenStyles.header.left}>
              <div
                style={{
                  borderRadius: "5px",
                  backgroundColor: "#fff",
                  height: "55vh",
                }}
              >
                <p
                  style={{
                    textAlign: "left",
                    fontSize: "0.9em",
                    padding: "1vh 0 1vh 1vw",
                    fontWeight: "500",
                    color: "#0F0718",
                    borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
                  }}
                >
                  Customers
                </p>
                <Scrollbars className="customerCardScroll">
                  {customerSearchResults.map((customerSearchResult, index) => (
                    <div
                      tabIndex={0}
                      onKeyPress={(e) => (e.charCode === 13 ? selectCustomer(index) : null)}
                      key={`${index}`}
                      style={data.posScreenStyles.customerModal.customerDropDownDetailsCard}
                    >
                      <Row
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          borderBottom: "1px solid #0000001F",
                          paddingBottom: "0.1%",
                          margin: "0 1.35vw",
                        }}
                      >
                        <Col span={1} style={{ paddingBottom: "1vh" }}>
                          <span
                            style={{
                              padding: "0.8vw 1.2vw",
                              backgroundColor: "rgba(146, 144, 152, 0.5)",
                              color: "rgba(15, 7, 24, 1)",
                              textAlign: "center",
                              borderRadius: "4px",
                              fontWeight: "500",
                              fontSize: "1.2em",
                            }}
                          >
                            {customerSearchResult.name.substring(0, 1)}
                          </span>
                        </Col>
                        <Col span={18} onClick={() => selectCustomer(index)} style={{ paddingLeft: "1.2vw" }}>
                          <p style={data.posScreenStyles.customerModal.customerName}>
                            {customerSearchResult.name} - {customerSearchResult.b2cCustomerSegment.name}
                          </p>
                          <p style={data.posScreenStyles.customerModal.customerStatus}>{customerSearchResult.mobileNo}</p>
                        </Col>
                        <Col
                          span={4}
                          style={{ display: "flex", alignItems: "center", justifyContent: "flex-end", paddingRight: "10px", paddingTop: "1vh", paddingBottom: "2.5vh" }}
                        >
                          <img onClick={() => showEditOldCustomerFields(customerSearchResult)} src={View} style={{ height: "3vh", marginRight: "5px" }} />
                          <img
                            onClick={() => {
                              showEditOldCustomerFields(customerSearchResult);
                              setEditFlag(true);
                            }}
                            src={EditIcon}
                            style={{ height: "3vh", marginRight: "5px", marginLeft: "0.5vw" }}
                          />
                          {/* <EditOutlined style={data.posScreenStyles.customerModal.dropdownCircleIcon} onClick={() => { showEditOldCustomerFields(customerSearchResult); setEditFlag(true); }} /> */}
                        </Col>
                      </Row>
                    </div>
                  ))}
                </Scrollbars>
                <Row justify="center" align="center" style={{ position: "relative", bottom: "-4vh", fontSize: "1vw" }}>
                  <img src={CustomerIcon} alt="CustomerIcon" style={{ height: "1.7vh", alignSelf: "center", paddingRight: "0.5vw" }} />
                  <span style={data.posScreenStyles.customerModal.addNewCustomer} onClick={showAddNewUAECustomerFields}>
                    {getMultilingualText("Add Customer")}
                  </span>
                </Row>
              </div>
            </div>
          ) : (
            <div style={data.posScreenStyles.header.left}>
                <div
                  bordered
                  style={{
                    ...data.posScreenStyles.customerModal.customerSearchListEmpty,
                    minHeight: "50vh",
                    maxHeight: "50vh",
                     width: "auto",
                  }}
                >
                <Row style={{ fontSize: "1vw" }}>
                  <p style={data.posScreenStyles.customerModal.noResultsText}>No results found</p>
                </Row>
                <Row justify="center" align="center">
                  <img src={CustomerIcon} alt="CustomerIcon" style={{ height: "1.7vh", alignSelf: "center", paddingRight: "0.5vw", paddingLeft: "5vw" }} />
                  <span style={data.posScreenStyles.customerModal.addNewCustomer} onClick={showAddNewUAECustomerFields}>
                    {getMultilingualText("Add Customer")}
                  </span>
                </Row>
              </div>
            </div>
          )}
        </Col>
      </Row>
    </Drawer>
  );
};

export default UAECustomerSearchDrawer;
